module.exports = __webpack_public_path__ + "img/logo_90.e2a6b562.png";